import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'shiftLabelShort',
    pure: true
})
export class ShiftLabelShortPipe implements PipeTransform {

    constructor(private translate: TranslateService) {}

    transform(shiftType: string, maxLength: number = 5): string {
        const full = this.translate.instant(shiftType);
        return full && full.length > maxLength ? full.slice(0, maxLength) : full;
    }
}
